<template>
    <div class="container">
        <div class="column">
            <div class="columns">
                <div class="spinner">
                    <div class="square"></div>
                    <div class="square"></div>
                    <div class="square"></div>
                    <div class="square clear"></div>
                    <div class="square"></div>
                    <div class="square"></div>
                    <div class="square clear"></div>
                    <div class="square"></div>
                    <div class="square"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Spinner",
}
</script>
